import * as ActionTypes from '../constants/ActionTypes';
import { server } from '../constants/SiteVariables';
import request from '../utils/request';

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

export const updateProperty = (label, value) => ({
  type: ActionTypes.UPDATE_PROPERTY,
  payload: {
    label: label,
    value: value
  }
});

export const updateNestedProperty = (path, value) => ({
  type: ActionTypes.UPDATE_NESTED_PROPERTY,
  payload: {
    path: path,
    value: value
  }
});

export const validateEmail = email => {
  return (dispatch, getState) => {
    return fetch(server() + '/api/registrations/' + encodeURIComponent(email) + '/validate/');
  }
}

export const getAccessCodeDetails = accessCode => {
  return (dispatch, getState) => {
    const code = accessCode || getState().registration.get('access_code');

    return fetch(server() + '/api/access_codes/' + code)
      .then(response => response.json());
  }
}

export const validateCode = (code, validate, legacyUserId) => {
  return (dispatch, getState) => {
    return fetch(server() + '/api/access_codes/' + code, { 
      method: 'GET'
    });
  }
}

export const register = () => {
  return (dispatch, getState) => {
    const state = getState().registration.toJS();

    var data = { 
      patient: {
        permission: 'member',
        cci: 'cci',
        code: state.access_code,
        first_name: state.first_name,
        last_name: state.last_name,
        email: state.email,
        gender: state.gender,
        password: state.password,
        zip: state.zip,
        permissions: state.permissions,
        preferences: state.preferences,
        terms: state.terms,
        mobile: true
      }
    }

    return request(server() + '/api/patients', {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data)
    });
  }
}

export const updatePatient = patient => {
  return (dispatch, getState) => {
    const data = getState().registration
      .delete('site')
      .delete('access_code_type')
      .delete('terms')
      .toJS();

    return fetch(server() + '/api/patients/' + patient.patient_id + '?access_token=' + patient.access_token, {
      method: 'PUT',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data)
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/registration.js